/**
 * 平台: 微信webview
 * 通用能力:
 * 1.bridge weixinReady (window.wx)
 * 2.登录: None
 * 3.定位: weixinLocate
 * 4.订阅: None
 * 5.分享: None
 */
import { query, build, getDchn, utils } from '@didi/webx-js-core';
import { sdkReady } from '../../loader';
import { request } from '../../../request/index';
import { getBranch } from '../../../initSDK';
import { storage } from '../../../storage';
import { WeixinJump } from './goTo';
function commonJump(loadParams, xenv, commonParams = {}) {
    new WeixinJump(loadParams, xenv, commonParams).doJump();
}
let cbs = [];
let errorMsg;
let hasTimer = false;
const passengerWXConfig = {
    sdkUrl: '//res.wx.qq.com/open/js/jweixin-1.6.0.js',
    signAPI: '//common.diditaxi.com.cn/general/webEntry/jsapiticket',
    srvno: 'didichuxing',
    apiList: [],
    openTagList: [],
    needConfig: true
};
const kfpassengerWXConfig = {
    sdkUrl: '//res.wx.qq.com/open/js/jweixin-1.6.0.js',
    signAPI: '//common.hongyibo.com.cn/webapp-api/jsapiticket',
    srvno: 'huaxiaozhudachechengke',
    caller: 'webx-js-kf',
    apiList: [],
    openTagList: [],
    needConfig: true
};
const cxappWXConfig = {
    sdkUrl: '//res.wx.qq.com/open/js/jweixin-1.6.0.js',
    signAPI: '//common.diditaxi.com.cn/general/webEntry/jsapiticket',
    srvno: 'chengxinyouxuan',
    apiList: [],
    openTagList: [],
    needConfig: true
};
function _getSDKConf() {
    let branch = getBranch();
    let exhaustiveCheck;
    switch (branch) {
        case 'passenger':
        case 'driver':
            return passengerWXConfig;
        case 'kfpassenger':
        case 'kfdriver':
            return kfpassengerWXConfig;
        case 'cxapp':
            return cxappWXConfig;
        default:
            exhaustiveCheck = branch; // eslint-disable-line
            return passengerWXConfig;
    }
}
const SELF_API_LIST = [
    'login',
    'getLocation',
    'hideOptionMenu',
    'showMenuItems',
    'hideMenuItems',
    'openLocation',
    /** 微信新的分享api */
    'updateAppMessageShareData',
    'updateTimelineShareData',
    /** 微信已经废弃分享api */
    'onMenuShareTimeline',
    'onMenuShareAppMessage',
    'onMenuShareQQ',
    'onMenuShareQZone'
];
function _configWeixin(conf) {
    request('POST', conf.signAPI, {
        data: {
            source: 'weixin',
            caller: conf.caller,
            url: window.location.href.replace(/#.*/, ''),
            srvno: conf.srvno
        },
        giveUpNineChapter: true,
        emulateJSON: true,
        needSign: true
    }).then((res) => {
        const wx = window.wx;
        const userApiList = conf.apiList;
        const selfOpenTagList = ['wx-open-launch-weapp', 'wx-open-launch-app'];
        const userOpenTagList = conf.openTagList;
        wx.config({
            beta: true,
            debug: false,
            ...res.data,
            jsApiList: SELF_API_LIST.concat(userApiList),
            openTagList: selfOpenTagList.concat(userOpenTagList)
        });
        wx.ready(() => {
            window.__wechatReady__ = true;
        });
        wx.error((res) => {
            errorMsg = res;
            window.__wechatReady__ = false;
        });
    }).catch(() => {
        errorMsg = 'jsapiTicket初始化失败';
        window.__wechatReady__ = false;
    });
}
function _waitForWechatReady() {
    if (hasTimer)
        return;
    hasTimer = true;
    function check() {
        if (window.__wechatReady__) {
            cbs.forEach(cb => cb(window.wx));
            return;
        }
        else if (window.__wechatReady__ === false) {
            cbs.forEach(cb => cb(null, errorMsg));
        }
        setTimeout(check, 100);
    }
    check();
}
function initWexin(conf) {
    // needConfig为false，只加载sdk，不进行wx.config
    if (!conf.needConfig) {
        sdkReady('wx', conf.sdkUrl, () => {
            cbs.forEach(cb => cb(window.wx));
        });
        return;
    }
    // needConfig为true，先加载sdk，再进行wx.config
    if (!window.__initWechat__) {
        // 未加载，自己加载
        window.__initWechat__ = true;
        sdkReady('wx', conf.sdkUrl, () => {
            _configWeixin(conf);
        });
    }
    _waitForWechatReady();
}
/**
 * 微信jssdk ready
 * @description
 *   weixinReady维护了不同品牌在初始化微信jssdk(wx.config)的默认配置
 *   如果需要覆盖默认配置、或者当前的品牌不在兼容列表中，则需要使用者手动传递option
 *
 *   注: weixinLocate会默认调用weixinReady。所以如果希望已自定义配置调用webx.locate时
 *     请首先通过自定义配置调用weixinReady
 * @param callback
 * @param option 用于覆盖wx.config的默认配置
 */
const weixinReady = (callback, option = {}) => {
    if (option.needConfig ? window.__wechatReady__ : window.wx) {
        callback(window.wx);
    }
    else {
        let weixinConf = Object.assign({}, _getSDKConf(), option);
        cbs.push(callback);
        initWexin(weixinConf);
    }
};
const weixinLocate = () => {
    return new Promise((resolve, reject) => {
        weixinReady(sdk => {
            if (sdk && sdk.getLocation) {
                sdk.getLocation({
                    type: 'gcj02',
                    success: (ret) => {
                        /* 获取定位信息成功 存入缓存 */
                        storage.locationInfo = {
                            lat: ret.latitude,
                            lng: ret.longitude
                        };
                        let newRiskParams = Object.assign({}, storage.riskParams, { latitude: ret.latitude, longitude: ret.longitude });
                        utils.cleanEmptyKey(newRiskParams);
                        storage.riskParams = newRiskParams;
                        resolve({
                            lat: ret.latitude,
                            lng: ret.longitude
                        });
                    },
                    cancel: (res) => {
                        /* 获取定位信息失败 存入缓存 */
                        storage.locationInfo = {};
                        let newRiskParams = Object.assign({}, storage.riskParams, { latitude: undefined, longitude: undefined });
                        utils.cleanEmptyKey(newRiskParams);
                        storage.riskParams = newRiskParams;
                        reject(res.errorMessage);
                    },
                    fail: (res) => {
                        /* 获取定位信息失败 存入缓存 */
                        storage.locationInfo = {};
                        let newRiskParams = Object.assign({}, storage.riskParams, { latitude: undefined, longitude: undefined });
                        utils.cleanEmptyKey(newRiskParams);
                        storage.riskParams = newRiskParams;
                        reject(res.errMsg);
                    }
                });
            }
            else {
                /* 获取定位信息失败 存入缓存 */
                storage.locationInfo = {};
                let newRiskParams = Object.assign({}, storage.riskParams, { latitude: undefined, longitude: undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                reject('微信sdk加载异常');
            }
        }, { needConfig: true });
    });
};
/* 设置右上角菜单 分享微信好友 */
const weixinShareAppMessage = (config) => {
    return new Promise((resolve, reject) => {
        weixinReady(wx => {
            if (wx && wx.updateAppMessageShareData) {
                /* 微信web直接分享时 只接受与当前一级域名相同的link来进行分享 */
                /* 考虑业务场景 多为实际打开长链而需分享短链 一级域名不一致的情况 */
                /* 因此加一层format 包含dchn的链接 根据xenv 转换实际分享链接 */
                let realLink = config.link;
                const dchn = getDchn(realLink);
                if (dchn) { // 如果是dchn链接
                    const params = query(realLink);
                    const branch = getBranch();
                    if (['passenger', 'kfpassenger', 'cxapp'].includes(branch)) {
                        switch (branch) {
                            case 'passenger': // 网约车环境
                            case 'cxapp': // 橙心优选环境
                                realLink = build(`https://v.xiaojukeji.com/${dchn}`, params);
                                break;
                            case 'kfpassenger': // 花小猪环境
                                realLink = build(`https://v.hongyibo.com.cn/${dchn}`, params);
                                break;
                        }
                    }
                }
                /* End format */
                wx.updateAppMessageShareData({
                    title: config.title,
                    desc: config.desc,
                    link: realLink || config.link,
                    imgUrl: config.imgUrl
                });
                resolve('success');
            }
            else if (wx && wx.onMenuShareAppMessage) {
                /* 微信web直接分享时 只接受与当前一级域名相同的link来进行分享 */
                /* 考虑业务场景 多为实际打开长链而需分享短链 一级域名不一致的情况 */
                /* 因此加一层format 包含dchn的链接 根据xenv 转换实际分享链接 */
                let realLink = config.link;
                const dchn = getDchn(realLink);
                if (dchn) { // 如果是dchn链接
                    const params = query(realLink);
                    const branch = getBranch();
                    if (['passenger', 'kfpassenger', 'cxapp'].includes(branch)) {
                        switch (branch) {
                            case 'passenger': // 网约车环境
                            case 'cxapp': // 橙心优选环境
                                realLink = build(`https://v.xiaojukeji.com/${dchn}`, params);
                                break;
                            case 'kfpassenger': // 花小猪环境
                                realLink = build(`https://v.hongyibo.com.cn/${dchn}`, params);
                                break;
                        }
                    }
                }
                /* End format */
                wx.onMenuShareAppMessage({
                    title: config.title,
                    desc: config.desc,
                    link: realLink || config.link,
                    imgUrl: config.imgUrl
                });
                resolve('success');
            }
            else {
                reject('微信sdk加载异常');
            }
        }, { needConfig: true });
    });
};
/* 设置右上角菜单 分享微信朋友圈 */
const weixinShareTimeLine = (config) => {
    return new Promise((resolve, reject) => {
        weixinReady(wx => {
            if (wx && wx.updateTimelineShareData) {
                wx.updateTimelineShareData({
                    title: config.title,
                    link: config.link,
                    imgUrl: config.imgUrl
                });
                resolve('success');
            }
            else if (wx && wx.onMenuShareTimeline) {
                wx.onMenuShareTimeline({
                    title: config.title,
                    link: config.link,
                    imgUrl: config.imgUrl
                });
                resolve('success');
            }
            else {
                reject('微信sdk加载异常');
            }
        }, { needConfig: true });
    });
};
const weixinDisableShare = () => {
    weixinReady(wx => {
        wx && wx.hideMenuItems({
            menuList: [
                'menuItem:share:appMessage',
                'menuItem:share:timeline',
                'menuItem:share:qq',
                'menuItem:share:weiboApp',
                'menuItem:share:facebook',
                'menuItem:share:QZone', // 分享到 QQ 空间
            ]
        });
    });
};
const weixinShare = (config) => {
    config.forEach(item => {
        switch (item.type) {
            case 'wx_appmsg': // 微信好友渠道
                weixinShareAppMessage(item); // 设置分享微信好友
                break;
            case 'wx_timeline': // 微信朋友圈渠道
                weixinShareTimeLine(item); // 设置分享微信朋友圈
                break;
        }
    });
};
const getPx = (num) => {
    let radio = document.documentElement.clientWidth / 750;
    return `${num * radio}px`;
};
/**
 * weixinInvokeShareMask
 * @description webview环境下 无主动分享机制时 蒙层兜底
 *   兼容微信
 */
const weixinInvokeShare = () => {
    const shadowImg = '//dpubstatic.udache.com/static/dpubimg/0e3e87f7-215c-48c2-9320-26577ad72bd2.png';
    const $dom = document.createElement('div');
    $dom.style.position = 'fixed';
    $dom.style.width = '100%';
    $dom.style.height = '100%';
    $dom.style.left = '0';
    $dom.style.top = '0';
    $dom.style.backgroundColor = 'rgba(0,0,0,.6)';
    $dom.style.zIndex = '10000';
    $dom.style.backgroundImage = `url(${shadowImg})`;
    $dom.style.backgroundRepeat = 'no-repeat';
    $dom.style.backgroundSize = `${getPx(270)} auto`;
    $dom.style.backgroundPositionY = '0';
    $dom.style.backgroundPositionX = getPx(750 - 270);
    setTimeout(() => {
        // 延时300ms后设置onclick方法，避免移动端点击穿透
        $dom.onclick = () => {
            document.body.removeChild($dom);
        };
    }, 300);
    document.body.appendChild($dom);
};
export { weixinReady, weixinLocate, commonJump as weixinCommonJump, weixinShare, weixinDisableShare, weixinInvokeShare };
